import { store } from "redux/store";

export const getHotelUserDashboardInncode = () => {
  const state = store.getState();

  const params = new URLSearchParams(window.location.search);
  let innCode = state.app.innCode;

  const searchParamsInncode = params.get("inncode");
  innCode = searchParamsInncode ?? innCode;
  return innCode;
};
